// @flow
import env from '../../../environment';
import {
  postCreator,
  getCreator,
  deleteCreator,
  putCreator,
} from '../../../http';

import type {
  PopupPositionType,
  PopupButtonActionType,
  PopupButtonEntityType,
  PopupTriggerType,
  PopupBannerTriggerValueCriteriaType,
} from '../../../entities';

export const endpoints = Object.freeze({
  CREATE_POPUP_BANNER: `${env.baseApiUrl}/ui/admin/store/pop-up`,
  GET_POPUP_BANNER: `${env.baseApiUrl}/ui/admin/store/pop-up`,
  DELETE_POPUP_BANNER: `${env.baseApiUrl}/ui/admin/store/pop-up/:bannerId`,
  TOGGLE_ENABLED_POPUP_BANNER: `${env.baseApiUrl}/ui/admin/store/pop-up/:bannerId`,
});

export const createPopupBannerApi = postCreator(endpoints.CREATE_POPUP_BANNER);
export const getPopupBannerApi = getCreator(endpoints.GET_POPUP_BANNER);
export const deletePopupBannerApi = deleteCreator(
  endpoints.DELETE_POPUP_BANNER
);
export const toggleEnabledPopupBannerApi = putCreator(
  endpoints.TOGGLE_ENABLED_POPUP_BANNER
);

export type CreatePopupBannerRequest = {
  imageId?: string,
  title?: string,
  subtitle?: string,
  backgroundColor: string,
  textColor?: string,
  popUpPositionType: PopupPositionType,
  buttonText: string,
  popUpButtonActionType: PopupButtonActionType,
  popUpButtonEntityType?: PopupButtonEntityType,
  buttonEntityIdentifier?: string,
  buttonBackgroundColor: string,
  buttonTextColor: string,
  popUpTriggerType: PopupTriggerType,
  popUpTriggerValue?: number,
  popUpTriggerValueCriteriaType: PopupBannerTriggerValueCriteriaType,
  enabled: boolean,
};
